import * as React from 'react';
import classNames from 'classnames';
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './FeaturedCatalogCarousel.module.scss';

type Props = {
    className?: string;
    next?: boolean;
    onClick?: (event: React.SyntheticEvent) => void;
    prev?: boolean;
    style?: any;
};

const Arrow = ({ className, next, onClick, prev, style }: Props) => {
    let icon = prev ? faChevronLeft : faChevronRight;
    const classes = classNames({ [styles.next]: next, [styles.previous]: !next }, className);

    return (
        <div className={classes} onClick={onClick} style={{ ...style }}>
            <FontAwesomeIcon icon={icon} />
        </div>
    );
};

export default React.memo<Props>(Arrow);
